import { useForm } from '../../../FormContext';
import Form from '../../Contact/Form/Form';
import classes from './FormModal.module.scss';

const FormModal = () => {
    const { isFormOpen, closeForm } = useForm();
    return (
        <div className={`${classes.wrap} ${isFormOpen ? classes.active : ''}`}>
            <div
                className={classes.close}
                onClick={closeForm}
            ></div>
            <div className={classes.body}>
                <Form />
            </div>
        </div>
    );
};

export default FormModal;
